import { createComponent } from 'react-fela'
import calculatePerBreakpoint from '../utils/calculatePerBreakpoint'

const Page = props => ({
  minWidth: '100%',
  width: '100%',
  minHeight: props.height,
  padding: props.noPadding ? 0 : '15px 0',
  overflow: 'hidden',
  justifyContent: 'center',
  backgroundColor: props.bgColor,
  backgroundImage: `url(${props.bgImage}${props.bgRetina ? '@2x' : ''}.jpg)`,
  backgroundSize: props.bgCover && 'cover' || '100% auto',
  backgroundPosition: '50%',
  extend: [
    calculatePerBreakpoint(props.heights, value => ({ minHeight: value })),
    calculatePerBreakpoint(props.bgImages, value => ({ backgroundImage: `url(${props.bgImage}_min${value}${props.bgRetina ? '@2x' : ''}.jpg)` }))
  ]
})

export default createComponent(Page, 'div', [
  'data-scroll-scope',
  'data-parallax-speed',
  'data-parallax-direction',
  'id'
])



// WEBPACK FOOTER //
// ../components/Page.js